import React from "react";
import {EventBus} from "../util/EventBus";
import {FormattedMessage} from "react-intl";

function QuantityModifier(props) {

    const onAddClick = (e) => {
        e.stopPropagation();
        if(!props.onlyLoggedUser) {
            props.increaseQuantity(e);
        }
        else {
            EventBus.dispatch("accessingOnlyInAppProduct");
        }
    };

    const bigSize = "big-size";




    return (


        <div className={props.bigSize? bigSize+" col quantity-modifier": "col quantity-modifier"} data-qa="quantity-modifier">
            {props.quantity === 0 ?
            <a
                onClick={onAddClick} className={!props.onlyLoggedUser? 'btn btn-default': 'btn btn-disabled'}> <FormattedMessage id="Add"/>
            </a>
                :

                (props.quantity === 1 ?
                        <>
                        <span data-qa="quantity-modifier-minus-btn" className="minus-btn danger" onClick={props.decreaseQuantity}>{props.bigSize?  <>&minus;</> : <>&times;</>}</span>
                        <span onClick={(e)=> e.stopPropagation()}className="qty-element">{props.quantity}</span>
                        <span data-qa="quantity-modifier-plus-btn" className="plus-btn" onClick={props.increaseQuantity}>+</span>
                        </>
                        :
                    <>
                        <span data-qa="quantity-modifier-minus-btn" className="minus-btn" onClick={props.decreaseQuantity}>&#8722;</span>
                        <span onClick={(e)=> e.stopPropagation()} className="qty-element">{props.quantity}</span>
                        <span data-qa="quantity-modifier-plus-btn" className="plus-btn" onClick={props.increaseQuantity}>+</span>
                    </>
                )
            }

        </div>
    );


}



export default QuantityModifier;
